import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess102002Status: 'idle',
    startProcess102002Error: undefined as any,
    loadUserParamsProcess102002Status: 'idle',
    loadUserParamsProcess102002Error: undefined as any,

    process102002List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess102002 = createAsyncThunk('process102002Slice/startProcess102002', async ({ process102002 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess102002/`,
        prepareData(process102002),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess102002Status } = getState().process102002Slice
        return startProcess102002Status !== 'pending'
    }
})

export const loadUserParamsProcess102002 = createAsyncThunk('process102002Slice/loadUserParamsProcess102002', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess102002/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess102002Status } = getState().process102002Slice
        return loadUserParamsProcess102002Status !== 'pending'
    }
})

const Process102002Slice = createSlice({
    name: 'process102002Slice',
    initialState,
    reducers: {
        resetstartProcess102002: (state) => {
            state.job = undefined
            state.startProcess102002Error = undefined
        },
        resetstartProcess102002Error: (state) => {
            state.startProcess102002Error = undefined
        },
        resetloadUserParamsProcess102002: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess102002Error = undefined
        },
        resetloadUserParamsProcess102002Error: (state) => {
            state.loadUserParamsProcess102002Error = undefined
        },
        removeFromProcess102002ListById: (state, action) => {
            state.process102002List = state.process102002List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess102002ListByIds: (state, action) => {
            state.process102002List = state.process102002List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process102002List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess102002Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process102002List = []
            state.startProcess102002Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess102002.pending, (state) => {
            state.startProcess102002Status = 'pending'
            state.startProcess102002Error = undefined
        })
        builder.addCase(startProcess102002.fulfilled, (state, action) => {
            state.startProcess102002Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess102002.rejected, (state, action) => {
            state.startProcess102002Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess102002Error = action.error.message
            } else {
                state.startProcess102002Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess102002.pending, (state) => {
            state.loadUserParamsProcess102002Status = 'pending'
            state.loadUserParamsProcess102002Error = undefined
        })
        builder.addCase(loadUserParamsProcess102002.fulfilled, (state, action) => {
            state.loadUserParamsProcess102002Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess102002.rejected, (state, action) => {
            state.loadUserParamsProcess102002Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess102002Error = action.error.message
            } else {
                state.loadUserParamsProcess102002Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess102002,
    resetstartProcess102002Error,
    resetloadUserParamsProcess102002,
    resetloadUserParamsProcess102002Error,
    removeFromProcess102002ListById,
    removeFromProcess102002ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process102002Slice.actions
export default Process102002Slice.reducer
